import React from "react";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "../components/common/ProtectedRoute";
import { RouteProtection } from "../components/common/RouteProtection";
import { DefaultRedirect } from "../components/common/DefaultRedirect";
import { Customers } from "../pages/Customers";
import { Layout } from "../components/layout/Layout";
import { CashIn } from "../pages/CashIn";
import { CashOut } from "../pages/CashOut";
import { Agents } from "../pages/Agents";
import { Countries } from "../pages/Countries";
import { Roles } from "../pages/Roles";
import { Staffs } from "../pages/Staffs";
import { Permissions } from "../pages/Permissions";
import { Surveillance } from "../pages/Surveillance";
import { Games } from "../pages/Games";
import { GameTables } from "../pages/GameTables";
import { CustomerDetail } from "../pages/CustomerDetail";
import { DailyEntries } from "../pages/DailyEntries";
import { CashRecords } from "../pages/CashRecords";
import { CountryDetail } from "../pages/CountryDetail";
import { GameRecords } from "../pages/GameRecords";
import { BlacklistedPlayers } from "../pages/BlacklistedPlayers";
import { FillTransaction } from "../pages/FillTransaction";
import { AgentDetails } from "../pages/AgentDetails";
import { PackageTypes } from "../pages/PackageTypes";
import { AgentAssignments } from "../pages/AgentAssignments";
import { PlayerDetails } from "../pages/PlayerDetails";
import MenuBar from "../pages/MenuBar";
import { FacilitiesCategories } from "../pages/FacilitiesCategories";
import { CommissionTypes } from "../pages/CommissionTypes";
import { PlayerCommissions } from "../pages/PlayerCommissions";
import { AuditLogs } from "../pages/AuditLogs";
import Dashboard from "../pages/Dashboard";

const PrivateRouter: React.FC = () => (
  <Routes>
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }
    >
      <Route index element={<DefaultRedirect />} />
      <Route
        path="dashboard"
        element={
          <RouteProtection routePath="/dashboard">
            <Dashboard />
          </RouteProtection>
        }
      />
      <Route
        path="customers"
        element={
          <RouteProtection routePath="/customers">
            <Customers />
          </RouteProtection>
        }
      />
      <Route
        path="daily-entries"
        element={
          <RouteProtection routePath="/daily-entries">
            <DailyEntries />
          </RouteProtection>
        }
      />
      <Route
        path="cash-in"
        element={
          <RouteProtection routePath="/cash-in">
            <CashIn />
          </RouteProtection>
        }
      />
      <Route
        path="cash-out"
        element={
          <RouteProtection routePath="/cash-out">
            <CashOut />
          </RouteProtection>
        }
      />
      <Route
        path="fill-transaction"
        element={
          <RouteProtection routePath="/fill-transaction">
            <FillTransaction />
          </RouteProtection>
        }
      />
      <Route
        path="cash-records"
        element={
          <RouteProtection routePath="/cash-records">
            <CashRecords />
          </RouteProtection>
        }
      />
      <Route
        path="agents"
        element={
          <RouteProtection routePath="/agents">
            <Agents />
          </RouteProtection>
        }
      />
      <Route
        path="agents/details"
        element={
          <RouteProtection routePath="/agents/details">
            <AgentDetails />
          </RouteProtection>
        }
      />
      <Route path="agents/:id" element={<AgentDetails />} />
      <Route
        path="countries"
        element={
          <RouteProtection routePath="/countries">
            <Countries />
          </RouteProtection>
        }
      />
      <Route
        path="permissions"
        element={
          <RouteProtection routePath="/permissions">
            <Permissions />
          </RouteProtection>
        }
      />
      <Route
        path="roles"
        element={
          <RouteProtection routePath="/roles">
            <Roles />
          </RouteProtection>
        }
      />
      <Route
        path="staffs"
        element={
          <RouteProtection routePath="/staffs">
            <Staffs />
          </RouteProtection>
        }
      />
      <Route
        path="surveillance"
        element={
          <RouteProtection routePath="/surveillance">
            <Surveillance />
          </RouteProtection>
        }
      />
      <Route
        path="games"
        element={
          <RouteProtection routePath="/games">
            <Games />
          </RouteProtection>
        }
      />
      <Route
        path="game-tables"
        element={
          <RouteProtection routePath="/game-tables">
            <GameTables />
          </RouteProtection>
        }
      />
      <Route
        path="game-records"
        element={
          <RouteProtection routePath="/game-records">
            <GameRecords />
          </RouteProtection>
        }
      />
      <Route
        path="blacklisted-players"
        element={
          <RouteProtection routePath="/blacklisted-players">
            <BlacklistedPlayers />
          </RouteProtection>
        }
      />
      <Route path="customers/:customerId" element={<CustomerDetail />} />
      <Route path="/countries/:id" element={<CountryDetail />} />
      <Route
        path="package-types"
        element={
          <RouteProtection routePath="/package-types">
            <PackageTypes />
          </RouteProtection>
        }
      />
      <Route
        path="agent-assignments"
        element={
          <RouteProtection routePath="/agent-assignments">
            <AgentAssignments />
          </RouteProtection>
        }
      />
      <Route
        path="player-details"
        element={
          <RouteProtection routePath="/player-details">
            <PlayerDetails />
          </RouteProtection>
        }
      />
      <Route
        path="facilities-categories"
        element={
          <RouteProtection routePath="/facilities-categories">
            <FacilitiesCategories />
          </RouteProtection>
        }
      />
      <Route
        path="menu-bar"
        element={
          <RouteProtection routePath="/menu-bar">
            <MenuBar />
          </RouteProtection>
        }
      />
      <Route
        path="commission-types"
        element={
          <RouteProtection routePath="/commission-types">
            <CommissionTypes />
          </RouteProtection>
        }
      />
      <Route
        path="player-commissions"
        element={
          <RouteProtection routePath="/player-commissions">
            <PlayerCommissions />
          </RouteProtection>
        }
      />
      <Route
        path="audit-logs"
        element={
          <RouteProtection routePath="/audit-logs">
            <AuditLogs />
          </RouteProtection>
        }
      />
    </Route>
  </Routes>
);

export default PrivateRouter;
